import React from 'react';
import { Input } from '@material-ui/core';
import _ from 'root/libs/exaforte/react/lodash';
import CustomFormInput from './CustomFormInput';
import InputAdornment from '@material-ui/core/InputAdornment';

export default class CustomMoneyField extends CustomFormInput {
    getSupportedProps() {
        return {...super.getSupportedProps(), ..._.filterSupportedProps(this.props, {multiline: true, rows: true, fullWidth: true, inputProps: true, endAdornment: true})};
    }
    
    getElement() {
        let props = this.getSupportedProps();

        if(_.is_empty(props.value))
            props.value = '';
        
        if(!props.endAdornment)
            props.endAdornment = <InputAdornment position="end">%</InputAdornment>;
        
        props.type          = 'number';
        props.inputProps    = {...{step: .01}, ...props.inputProps};

        return <Input autoComplete="off" disableUnderline={true} onChange={this._onChange} {...props} />;
    }
}